// AD-2407: a group saved with no parent group is a top-level group. If any of the new groups has no category, the
// member of staff is asked first, as on the Profiles page.
export const needsNoCategoryWarning = (parentGroupFilterId, rows) =>
    !parentGroupFilterId && (rows ?? []).some(row => !row.formCategoryId);
